import { Dispatch, useEffect, useState } from "react";
import axios from 'axios';
import { ManifestProps } from "../types";
import { IADPActions } from "../state/Actions";
import { actions } from "../state";
import { environment } from "../util/util";
const logPrefix = "[ADPClient][ConfigServiceHook]"
export function useManifestService(dispatch:Dispatch<IADPActions>) {
  const [manifest, setManifest] = useState<ManifestProps>();
  function fetchManifest() {
    console.log(logPrefix,"fetching manifest...");
    axios.get(`${environment.resovleAppDomain()}/manifest/naep.manifest.json`)
  .then(function (response) {
    console.log(logPrefix,"manifest fetch status", response.status);
    const transformedManifest:ManifestProps = {
      release : response.data.manifest?.product,
      app: response.data.manifest?.app
    }
     setManifest(transformedManifest);
  })
  .catch(function (error) {
    // handle error
    console.log(logPrefix,"error fetching manifest",error);
     dispatch(actions.createSetViewAction("LoadingErrroView"));
  })
  }
  useEffect(() => {
    fetchManifest();
  }, []);
  return manifest;
}
